import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Comment } from 'src/app/models/comment.model';
import { PageType } from 'src/app/models/enum/page-type.enum';
import { Item } from 'src/app/models/item.model';
import { LookupService } from 'src/app/services/lookup.service';
import { JobService } from 'src/app/services/sections/job/job.service';
import { ButtonIcons } from '../../action-button/models/button-icons.enum';

import * as moment from 'moment';
import { GlobalSettingsService } from 'src/app/services/ui/global-settings.service';
import { FollowUpService } from 'src/app/services/sections/job/follow-up.service';


@Component({
	templateUrl: './follow-up-edit.component.html',
	styleUrls: ['./follow-up-edit.component.scss', '../../stylesheets/job-actions.scss', '../../stylesheets/job-main.scss', '../../stylesheets/job-inputs.scss']
})
export class FollowUpEditComponent implements OnInit, OnDestroy {

	public formModel: FormGroup;
	public followUpTypeOptions: Item<number, string>[];

	public readonly PageType = PageType;
	public readonly ButtonIcons = ButtonIcons;

	public followUp: Comment = null;

	public unsubscriber$ = new Subject<void>();
	public isLoading = false;

	public self = this;

	constructor(
		private router: Router,
		private activatedRoute: ActivatedRoute,
		private lookupService: LookupService,
		private followUpService: FollowUpService
	) { }

	ngOnInit(): void {
		this.followUp = (this.activatedRoute.snapshot.data.followUp || {}) as Comment;
		GlobalSettingsService.isSecondaryLoaderLoading = true;

		this.isLoading = true;

		this.lookupService.getJobFollowUpTypes()
			.pipe(takeUntil(this.unsubscriber$))
			.subscribe((types) => {
				this.followUpTypeOptions = types;

				this.formModel = new FormGroup({
					description: new FormControl(this.followUp.description, [Validators.required, Validators.minLength(10), Validators.pattern(/\S+/)]),
					jobFollowUpTypeId: new FormControl(null),
					dueDate: new FormControl(this.followUp.dueDate)
				});

				this.isLoading = false;
				GlobalSettingsService.isSecondaryLoaderLoading = false;
			});
	}

	public ngOnDestroy(): void {
		this.unsubscriber$.next();
		this.unsubscriber$.complete();
	}

	public submitComment(): void {
		const model = this.formModel.getRawValue();
		model.dueDate = model.dueDate ? moment(model.dueDate).format('YYYY-MM-DD') : null;

		GlobalSettingsService.isSecondaryLoaderLoading = true;

		this.followUpService.updateJobFollowUp(this.activatedRoute.snapshot.paramMap.get('token'), model)
			.subscribe(
				() => {
					this.router.navigate(['../'], { relativeTo: this.activatedRoute });
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				},
				() => {
					GlobalSettingsService.isSecondaryLoaderLoading = false;
				});
	}
}
